import { createSelectorCreator } from 'reselect'
import { shallowEqualArrays, shallowEqualObjects } from 'shallow-equal'

const isNonNullObject = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object'

const resultMemoize = <Args extends unknown[], Result>(func: (...args: Args) => Result) => {
  let lastArgs: Args | null = null
  let lastResult!: Result
  let hasResult = false

  return (...args: Args): Result => {
    if (!hasResult) {
      lastArgs = args
      lastResult = func(...args)
      hasResult = true
      return lastResult
    }

    if (!shallowEqualArrays(lastArgs, args)) {
      const nextResult = func(...args)
      const shouldKeepLastResult =
        (Array.isArray(nextResult) && Array.isArray(lastResult) && shallowEqualArrays(nextResult, lastResult)) ||
        (isNonNullObject(nextResult) && isNonNullObject(lastResult) && shallowEqualObjects(nextResult, lastResult))

      if (!shouldKeepLastResult) {
        lastResult = nextResult
      }
    }

    lastArgs = args
    return lastResult
  }
}

const createResultCheckingSelector = createSelectorCreator(resultMemoize)

export default createResultCheckingSelector
